import { CommonModule } from '@angular/common';
import { InjectionToken, ModuleWithProviders, NgModule, Type } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { PrivacyPolicyModalComponent } from './privacy-policy-modal/privacy-policy-modal.component';
import { PrivacyPolicyService } from './privacy-policy.service';
import { HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';

interface PrivacyPolicyConfig {
  privacyPolicyUrl: string;
}
export const PRIVACY_POLICY_CONFIG = new InjectionToken<PrivacyPolicyConfig>('PRIVACY_POLICY_CONFIG');

export interface AcceptPrivacyPolicyService {
  acceptPrivacyPolicy(params?: { context?: HttpContext }): Observable<void>;
}
export const PROFILE_SERVICE = new InjectionToken<AcceptPrivacyPolicyService>('PRIVACY_POLICY_PROFILE_SERVICE');

@NgModule({
  imports: [IonicModule, CommonModule, PrivacyPolicyModalComponent],
})
export class PrivacyPolicyModule {
  static forRoot(
    config: PrivacyPolicyConfig & { acceptPrivacyPolicyService: Type<AcceptPrivacyPolicyService> },
  ): ModuleWithProviders<PrivacyPolicyModule> {
    return {
      ngModule: PrivacyPolicyModule,
      providers: [
        PrivacyPolicyService,
        {
          provide: PRIVACY_POLICY_CONFIG,
          useValue: config,
        },
        {
          provide: PROFILE_SERVICE,
          useClass: config.acceptPrivacyPolicyService,
        },
      ],
    };
  }
}
